// @ts-nocheck
/* Port of ReleaseTypeBadge.js (18L). BYTE-IDENTICAL. */
import React from 'react';
import { getTypeMeta } from './releaseUtils';

const ReleaseTypeBadge = ({ type }: any) => {
  const meta = getTypeMeta(type);
  return (
    <span
      className="rc-type"
      style={{ color: meta.color, background: meta.bg }}
    >
      <span aria-hidden="true">{meta.icon}</span>
      {type}
    </span>
  );
};

export default ReleaseTypeBadge;
